import { Control, Field, generateRuleList, Input } from "@quortex/front-common"
import { useFormContext } from "react-hook-form"
import {
  type ContentSteeringServerFormType,
  dashUrlPattern,
  hlsUrlPattern
} from "@/App/play/App/Main/Settings/ContentSteering/helpers"

const ThirdPartyUrlsFields = () => {
  const form = useFormContext<ContentSteeringServerFormType>()

  return (
    <>
      <p className="mt-lg mb-sm font-medium">Third-party URLs</p>
      <Field className="mb-sm" isCopiable label="DASH manifests" name="dashServerAddress">
        {name => (
          <Control
            {...form.register(name, {
              ...generateRuleList({ pattern: dashUrlPattern, required: true })
            })}
            as={Input}
            className="w-[20rem]"
            placeholder="Enter a URL"
          />
        )}
      </Field>

      <Field isCopiable label="HLS playlists" name="hlsServerAddress">
        {name => (
          <Control
            {...form.register(name, {
              ...generateRuleList({ pattern: hlsUrlPattern, required: true })
            })}
            as={Input}
            className="w-[20rem]"
            placeholder="Enter a URL"
          />
        )}
      </Field>
    </>
  )
}

export default ThirdPartyUrlsFields
